import { RouteConfig } from 'vue-router'
import { integrationsRouteNames } from '@/routes/constants/location'
import { requireAuthAndLocation } from '../auth'

const Integration = () =>
  import('@/pmd/pages/agency/Integration.vue').then(m => m.default)

export const integrationsRoute: RouteConfig[] = [
  {
    path: 'integration',
    name: integrationsRouteNames.default,
    component: Integration,
    beforeEnter: requireAuthAndLocation,
    children: [
      {
        path: ':appId/upgrade-plans',
        name: integrationsRouteNames.appUpgradePlans,
        component: Integration,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: ':appId',
        name: integrationsRouteNames.appAnyApp,
        component: Integration,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: ':appId/versions/:versionId',
        name: integrationsRouteNames.appVersion,
        component: Integration,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: ':appId/update-app',
        name: integrationsRouteNames.updateApp,
        component: Integration,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: ':pathMatch(.*)*',
        name: integrationsRouteNames.notFound,
        component: Integration,
        beforeEnter: requireAuthAndLocation,
      },
    ],
  }
]
